import React from 'react';
import PropTypes from 'prop-types';

import { ListItemButton as MUIListItemButton } from '@mui/material';

export const ListItemButton = props => <MUIListItemButton {...props} />;

ListItemButton.propTypes = {
  alignItems: PropTypes.oneOf(['flex-start', 'center']),
  classes: PropTypes.object,
  component: PropTypes.elementType,
  dense: PropTypes.bool,
  disableGutters: PropTypes.bool,
  disabled: PropTypes.bool,
  divider: PropTypes.bool,
  selected: PropTypes.bool
};

export default ListItemButton;
